import { useEffect, useState } from "react";
import classnames from "classnames";
import { useSelector } from "react-redux";
import {
    Row,
    Col,
    Table,
    Input,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label
} from "reactstrap";
import { POST_KPI_DASHBOARD } from "../../helpers/data_helper";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import Loader from "../../Components/Common/Loader";
import ExportExcel from "../../Components/Common/ExportExcel";
import ExportExcelBudget from "../../Components/Common/ExportExcelBudget";

const BudgetTab = (props) => {
    const {filterData, filterAjax, handleToastMessage}=props;

    const [serverPerformanceAjax, setServerPerformanceAjax] = useState(true);
    const [dateWiseData, setDateWiseData] = useState([]);
    const [aggregator, setAggregator] = useState("Month");
    const [year, setYear] = useState(new Date().getFullYear());
    const [mealPeriod, setMealPeriod] = useState(0);
    const [filtermealperiod, setFiltermealperiod] = useState([]);
    const [ChangedCover, setChangedCover] = useState({});
    const [ChangedRevenue, setChangedRevenue] = useState({});
    const [originalData, setOriginalData] = useState(dateWiseData);
    const [hideOldDiv, setHideOldDiv] = useState(false);
    const [changedAvgTime, setChangedAvgTime] = useState({});
    const [changedAvgCoverCheck, setChangedAvgCoverCheck] = useState({});
    const [ResChangedCover, setResChangedCover] = useState({});
    const [ResChangedRevenue, setResChangedRevenue] = useState({});
    const [ChangedNoOfAdults, setChangedNoOfAdults] = useState({});
    const [exportData, setExportData] = useState({});

    const [showImportModal, setShowImportModal] = useState(false);
    const [importFile, setImportFile] = useState(null);
    const [importAggregator, setImportAggregator] = useState("Month");
    const [importYear, setImportYear] = useState(new Date().getFullYear());
    const [importMealPeriod, setImportMealPeriod] = useState(0);
    const [importLoading, setImportLoading] = useState(false);


    useEffect(() => {

        if (filterData.mealperiod) {
            setFiltermealperiod(filterData.mealperiod);
        }
    }, [filterAjax, filterData]);

    useEffect(() => {
        getInfo(mealPeriod, aggregator, year);
    }, [mealPeriod, aggregator, year]);

    const getInfo = (mealPeriod, aggregator, year) => {
        setServerPerformanceAjax(true);
        setHideOldDiv(false);
        postDataAPI({
            serviceName: POST_KPI_DASHBOARD.serviceName,
            op: POST_KPI_DASHBOARD.budget_forecast_list_op,
            mealPeriod: mealPeriod,
            budgetSelectRange: aggregator,
            budgetYear: year
        }).then(response => {
            if (response.status === 'ok') {
                setDateWiseData(response.data.data);
                setOriginalData(response.data.data);
                setServerPerformanceAjax(false);
                const exportData = response.data.data.map(item => ({
                    [aggregator == "Month" ? "Months" : "Date"]: item.from_date_display || "",
                    "Covers": Number(item.covers) || 0,
                    "Revenue": Number(item.revenue) || 0,
                    "Avg Check": Number(item.avg_check) || 0,
                    "Avg Time": Number(item.avg_time) || 0,
                    "Avg covers/check": Number(item.avg_covers_check) || 0,
                    "Resident Covers": Number(item.resCover) || 0,
                    "Resident Revenue": Number(item.resRevenue) || 0,
                    "No of Adults": Number(item.no_of_adults) || 0
                }));
                setExportData(exportData);
            } else {
                // console.log(response);
            }
        });
    }

    const handleaggregator = (event) => {
        setAggregator(event.target.value);
    }

    const handleYear = (event) => {
        setYear(event.target.value);
    }

    const handleMealPeriod = (event) => {
        setMealPeriod(event.target.value);
    }

    const handleInputCover = (event, date) => {
        setHideOldDiv(true);
        const { name, value } = event.target;
        setDateWiseData(dateWiseData.map((data) => {
            if (data.from_date_display == date) {
                data[name] = value;
            }
            return data;
        }));
        // Update the changed inputs state
        setChangedCover({ ...ChangedCover, [date]: true });
        // if (value != '0' && value != '') {
        //     setCheckboxChecked(date, true);
        // } else {
        //     setCheckboxChecked(date, false);
        // }
        setCheckboxChecked(date, true);

        // Calculate Average Check if Revenue is available
        const revenue = dateWiseData.find(data => data.from_date_display == date)?.revenue || 0;
        if (revenue && value != '' && value != '0') {
            const avg_check = parseFloat(revenue) / parseFloat(value);
            // console.log('Average Check:', avg_check);
            setDateWiseData(dateWiseData.map((data) => {
                if (data.from_date_display == date) {
                    data['avg_check'] = avg_check.toFixed(2);
                }
                return data;
            }));
            // Set the Average Check in your state or perform further actions as needed
        }
    }

    const handleInputRevenue = (event, date) => {
        setHideOldDiv(true);
        const { name, value } = event.target;
        setDateWiseData(dateWiseData.map((data) => {
            if (data.from_date_display == date) {
                data[name] = value;
            }
            return data;
        }));
        // Update the changed inputs state
        setChangedRevenue({ ...ChangedRevenue, [date]: true });
        // if (value != '0' && value != '') {
        //     setCheckboxChecked(date, true);
        // } else {
        //     setCheckboxChecked(date, false);
        // }
        setCheckboxChecked(date, true);

        // Calculate Average Check if Covers is available
        const covers = dateWiseData.find(data => data.from_date_display == date)?.covers || 0;
        if (covers && value != '' && value != '0') {
            const avg_check = parseFloat(value) / parseFloat(covers);
            // console.log('Average Check:', avg_check);
            setDateWiseData(dateWiseData.map((data) => {
                if (data.from_date_display == date) {
                    data['avg_check'] = avg_check.toFixed(2);
                }
                return data;
            }));
            // Set the Average Check in your state or perform further actions as needed
        }
    }

    const handleInputAvgCheck = (event, date) => {
        const { name, value } = event.target;
        setDateWiseData(dateWiseData.map((data) => {
            if (data.from_date_display == date) {
                data['avg_check'] = value;
            }
            return data;
        }));   
        const covers = dateWiseData.find(data => data.from_date_display == date)?.covers || 0;
        const revenue = parseFloat(covers) * parseFloat(value); 
        if(covers !== 0){
            setDateWiseData(dateWiseData.map((data) => {
                if (data.from_date_display == date) {
                    data['revenue'] = revenue.toFixed(2);
                }
                return data;
            }));
        }
        // Update the changed inputs state
        setChangedCover({ ...ChangedCover, [date]: true });
        // if (value != '0' && value != '') {
        //     setCheckboxChecked(date, true);
        // } else {
        //     setCheckboxChecked(date, false);
        // }
        setCheckboxChecked(date, true);
    }

    const handleInputAvgTime = (event, date) => {
        setHideOldDiv(true);
        const { name, value } = event.target;
        setDateWiseData(dateWiseData.map((data) => {
            if (data.from_date_display == date) {
                data[name] = value;
            }
            return data;
        }));
        // Update the changed inputs state
        setChangedAvgTime({ ...changedAvgTime, [date]: true });
        
        setCheckboxChecked(date, true);
    }

    const handleInputAvgCoverCheck = (event, date) => {
        setHideOldDiv(true);
        const { name, value } = event.target;
        setDateWiseData(dateWiseData.map((data) => {
            if (data.from_date_display == date) {
                data[name] = value;
            }
            return data;
        }));
        // Update the changed inputs state
        setChangedAvgCoverCheck({ ...changedAvgCoverCheck, [date]: true });
        
        setCheckboxChecked(date, true);
    }

    const handleSubmit = () => {
        setServerPerformanceAjax(true);
        const checkedRowsData = [];
        for (let i = 0; i < dateWiseData.length; i++) {

            let valId = 'budget_checkbox_' + i;
            var checkbox = document.getElementById(valId);
            if (checkbox.checked) {
                checkedRowsData.push({
                    "br_id": dateWiseData[i]['br_id'],
                    "covers": dateWiseData[i]['covers'],
                    "revenue": dateWiseData[i]['revenue'],
                    "avg_time": dateWiseData[i]['avg_time'],
                    "avg_covers_check": dateWiseData[i]['avg_covers_check'],
                    // "avg_check": dateWiseData[i]['avg_check'],
                    "resCover": dateWiseData[i]['resCover'],
                    "resRevenue": dateWiseData[i]['resRevenue'],
                    "no_of_adults": dateWiseData[i]['no_of_adults'],
                });
            } else {
                // console.log('Checkbox is not checked');
            }

        }
        // console.log("Checked Rows Data:", checkedRowsData);
        postDataAPI({
            serviceName: POST_KPI_DASHBOARD.serviceName,
            op: POST_KPI_DASHBOARD.save_budget_data_op,
            mealPeriod: mealPeriod,
            budgetSelectRange: aggregator,
            budgetYear: year,
            budget_data: checkedRowsData
        }).then(response => {
            if (response.status === "ok") {
                handleToastMessage('success', response.message);
                setServerPerformanceAjax(false);
                setTimeout(() => {
                    // window.location.reload();
                }, 2000);
                getInfo(mealPeriod, aggregator, year);
            } else {
                handleToastMessage('error', response.message);
            }
        });
    };

    const setCheckboxChecked = (date, checked) => {
        setDateWiseData(dateWiseData.map((data) => {
            if (data.from_date_display === date) {
                data.isChecked = checked;
            }
            return data;
        }));
    };

    const handleInputResCover = (event, date) => {
        setHideOldDiv(true);
        const { name, value } = event.target;
        setDateWiseData(dateWiseData.map((data) => {
            if (data.from_date_display == date) {
                data[name] = value;
            }
            return data;
        }));
        // Update the changed inputs state
        setResChangedCover({ ...ResChangedCover, [date]: true });
        setCheckboxChecked(date, true);
    }
    const handleInputResRevenue = (event, date) => {
        setHideOldDiv(true);
        const { name, value } = event.target;
        setDateWiseData(dateWiseData.map((data) => {
            if (data.from_date_display == date) {
                data[name] = value;
            }
            return data;
        }));
        // Update the changed inputs state
        setResChangedRevenue({ ...ResChangedRevenue, [date]: true });
        setCheckboxChecked(date, true);
    }
    const handleInputNoOfAdults = (event, date) => {
        setHideOldDiv(true);
        const { name, value } = event.target;
        
        setDateWiseData(dateWiseData.map((data) => {
            if (data.from_date_display == date) {
                data[name] = value;
            }
            return data;
        }));
        // Update the changed inputs state
        setChangedNoOfAdults({ ...ChangedNoOfAdults, [date]: true });
        
        setCheckboxChecked(date, true);
    }

    const handleImportSubmit = async () => {
        if (!importFile) {
            handleToastMessage("error", "Please select Excel file");
            return;
        }

        if (importFile.size > 10 * 1024 * 1024) {
            handleToastMessage("error", "File must be less than 10MB");
            return;
        }

        try {
            setImportLoading(true);

            const res = await postDataAPI({
            serviceName: "budget_import_export",
            op: "import-budget-data",
            excel_file: importFile,
            selectedOutletID: filterData?.outlet_id,
            mealPeriod: importMealPeriod,
            time_period: importAggregator.toLowerCase(),
            year: importYear
            });

            if (res.status === "ok") {
                handleToastMessage("success", res.message || "Imported successfully");
                setShowImportModal(false);
                getInfo(mealPeriod, aggregator, year);
            } else {
                handleToastMessage("error", res.message);
            }

        } catch (err) {
            handleToastMessage("error", "Import failed");
        } finally {
            setImportLoading(false);
        }
    };


    return (
        <>
            <Row>
                <Col lg={3} >
                    <select value={aggregator} onChange={handleaggregator} className="form-select mb-3">
                        <option value="Day">Day</option>
                        <option value="Week">Week</option>
                        <option value="Month">Month</option>
                        <option value="Year">Year</option>
                    </select>
                </Col>
                <Col lg={3}>
                    <select value={year} onChange={handleYear} className="form-select mb-3">
                        <option value="2023">2023</option>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                    </select>
                </Col>
                <Col lg={3}>
                    <select
                        className="form-select"
                        value={mealPeriod}
                        id="mealPeriod"
                        onChange={handleMealPeriod}
                    >
                        <option value="0">All Meal Periods</option>
                        {!filterAjax &&
                            filtermealperiod.length > 0 &&
                            filtermealperiod.map((item) => {
                                return (
                                    <option key={item.sp_id} value={item.sp_id}>
                                        {item.title +
                                            " (" +
                                            item.start_time +
                                            " To " +
                                            item.end_time +
                                            ")"}
                                    </option>
                                );
                            })}
                    </select>
                </Col>
                <Col lg={3} className="text-end">
                    {/* <button className="btn btn-secondary ms-2"
                        style={{ float: 'right' }}
                        onClick={handleExport}>
                        Export
                    </button> */}
                    
                                  
                    <button className="btn btn-primary me-2"
                        //style={{ float: 'right' }}
                        onClick={handleSubmit}>
                        Save
                    </button>

                    <ExportExcelBudget fileName="Budget_Report" filteredData={exportData} filterType={aggregator} />
                    <Button
                        className="me-2"
                        color="info"
                        onClick={() => setShowImportModal(true)}
                    >
                    Import
                    </Button>

                </Col>
            </Row>
            {serverPerformanceAjax && <Loader />}
            <div
                className={
                    serverPerformanceAjax
                        ? "opacity-0"
                        : ""
                }
            >
                <div className="table-responsive">
                    <Table className="table-bordered table-nowrap text-center align-middle mb-0 table-sm">
                        <thead style={{ position: 'sticky', top: '-2px', background: '#fff', zIndex: '10' }}>
                            <tr>
                                <th className="text-center" scope="col" >{aggregator == 'Month' ? 'Months' : 'Date'}</th>
                                <th className="text-center" scope="col" >Covers</th>
                                <th className="text-center" scope="col" >Revenue</th>
                                <th className="text-center" scope="col" >Avg Check</th>
                                <th className="text-center" scope="col">Avg Time</th>
                                <th className="text-center" scope="col" >Avg covers/<br />check</th>
                                <th className="text-center" scope="col">Resident<br /> Covers</th>
                                <th className="text-center" scope="col">Resident<br /> Revenue</th>
                                <th className="text-center" scope="col">No of Adults</th>
                                <th className="text-center" scope="col">Apply</th>
                            </tr>
                        </thead>
                        <tbody 
                        //style={{ maxHeight: '400px', background: '#fff', display: 'table-caption' }}
                        >
                            {dateWiseData.map((data, index) => {
                                const checkboxId_budget = `budget_checkbox_${index}`;
                                return (
                                    <tr key={data.from_date} 
                                    //style={{ width: '100%', display: 'inline-table' }}
                                    >
                                        <td >{data.from_date_display}</td>
                                        <td >
                                            <div style={{ width: '100%'}}>
                                                    <Input
                                                        name="covers"
                                                        className="form-control form-control-sm"
                                                        type="number"
                                                        value={data.covers}
                                                        style={{ maxWidth: "150px", margin: "auto", fontSize: '13px' }}
                                                        onChange={(event) => handleInputCover(event, data.from_date_display)}
                                                    // onBlur={(event) => handleInputCover(event, data.from_date_display)}
                                                    />
                                                {hideOldDiv && ChangedCover[data.from_date_display] && (
                                                    <div style={{ marginTop: '4px', textAlign: 'center' }}>
                                                        {originalData.find(d => d.from_date_display === data.from_date_display) && originalData.find(d => d.from_date_display === data.from_date_display).oCovers !== '' ? (
                                                            // <div style={{ background: '#f06548', padding: '3px 10px', borderRadius: '4px', color: '#fff', width: 'max-content' }}>
                                                            <div style={{
                                                                background: '#f06548',
                                                                padding: '2px 8px',
                                                                borderRadius: '4px',
                                                                color: '#fff',
                                                                fontSize: '11px',
                                                                display: 'inline-block'
                                                                }}>
                                                                Old : {originalData.find(d => d.from_date_display === data.from_date_display).oCovers}
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td >
                                            <div style={{ width: '100%' }}>
                                                    <Input
                                                        name="revenue"
                                                        className="form-control form-control-sm"
                                                        type="number"
                                                        value={data.revenue}
                                                        style={{ maxWidth: "150px", margin: 'auto', fontSize: '13px' }}
                                                        onChange={(event) => handleInputRevenue(event, data.from_date_display)}
                                                    // onBlur={(event) => handleInputRevenue(event, data.from_date_display)}
                                                    />
                                                {hideOldDiv && ChangedRevenue[data.from_date_display] && (
                                                    <div style={{ marginTop: '4px', textAlign: 'center' }}>
                                                        {originalData.find(d => d.from_date_display === data.from_date_display) && originalData.find(d => d.from_date_display === data.from_date_display).oRevenue !== '' ? (
                                                            <div style={{
                                                                background: '#f06548',
                                                                padding: '2px 8px',
                                                                borderRadius: '4px',
                                                                color: '#fff',
                                                                fontSize: '11px',
                                                                display: 'inline-block'
                                                                }}>
                                                                Old : {originalData.find(d => d.from_date_display === data.from_date_display).oRevenue}
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <Input
                                                name="avg_check"
                                                className="form-control form-control-sm"
                                                type="number"
                                                value={data.avg_check}
                                                style={{ maxWidth: "150px", margin: "auto", fontSize: '13px' }}
                                                onChange={(event) => handleInputAvgCheck(event, data.from_date_display)}
                                            // onBlur={(event) => handleInputAvgCheck(event, data.from_date_display)}
                                            />
                                        </td>
                                        <td>
                                            <div style={{ width: '100%', display: 'flex' }}>
                                                <div style={{ width: '100%' }}>
                                                    <Input
                                                        name="avg_time"
                                                        className="form-control form-control-sm"
                                                        type="number"
                                                        value={data.avg_time}
                                                        style={{ maxWidth: "150px", margin: 'auto', fontSize: '13px' }}
                                                        onChange={(event) => handleInputAvgTime(event, data.from_date_display)}
                                                    />
                                                </div>
                                                
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ width: '100%', display: 'flex' }}>
                                                <div style={{ width: '100%' }}>
                                                    <Input
                                                        name="avg_covers_check"
                                                        className="form-control form-control-sm"
                                                        type="number"
                                                        value={data.avg_covers_check ?? ""}
                                                        style={{ maxWidth: "150px", margin: 'auto', fontSize: '13px' }}
                                                        onChange={(event) => handleInputAvgCoverCheck(event, data.from_date_display)}
                                                    />
                                                </div>
                                                
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ width: '100%' }}>
                                                <Input
                                                    name="resCover"
                                                    className="form-control form-control-sm"
                                                    type="number"
                                                    value={data.resCover}
                                                    style={{ maxWidth: "150px", margin: "auto", fontSize: '13px' }}
                                                    onChange={(event) => handleInputResCover(event, data.from_date_display)}
                                                // onBlur={(event) => handleInputCover(event, data.from_date_display)}
                                                />
                                                {hideOldDiv && ResChangedCover[data.from_date_display] && (
                                                    <div style={{ marginTop: '4px', textAlign: 'center' }}>
                                                        {originalData.find(d => d.from_date_display === data.from_date_display) && originalData.find(d => d.from_date_display === data.from_date_display).oResCovers !== '' ? (
                                                            <div style={{
                                                                background: '#f06548',
                                                                padding: '2px 8px',
                                                                borderRadius: '4px',
                                                                color: '#fff',
                                                                fontSize: '11px',
                                                                display: 'inline-block'
                                                                }}>
                                                                Old : {originalData.find(d => d.from_date_display === data.from_date_display).oResCovers}
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                        
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ width: '100%'}}>
                                                <Input
                                                    name="resRevenue"
                                                    className="form-control form-control-sm"
                                                    type="number"
                                                    value={data.resRevenue}
                                                    style={{ maxWidth: "150px", margin: 'auto', fontSize: '13px' }}
                                                    onChange={(event) => handleInputResRevenue(event, data.from_date_display)}
                                                // onBlur={(event) => handleInputRevenue(event, data.from_date_display)}
                                                />
                                                {hideOldDiv && ResChangedRevenue[data.from_date_display] && (                                                    
                                                    <div style={{ marginTop: '4px', textAlign: 'center' }}>
                                                    {originalData.find(d => d.from_date_display === data.from_date_display) && originalData.find(d => d.from_date_display === data.from_date_display).oResRevenue !== '' ? (
                                                        <div style={{
                                                            background: '#f06548',
                                                            padding: '2px 8px',
                                                            borderRadius: '4px',
                                                            color: '#fff',
                                                            fontSize: '11px',
                                                            display: 'inline-block'
                                                            }}>
                                                            Old : {originalData.find(d => d.from_date_display === data.from_date_display).oResRevenue}
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ width: '100%' }}>
                                                <Input
                                                    name="no_of_adults"
                                                    className="form-control form-control-sm"
                                                    type="number"
                                                    value={data.no_of_adults}
                                                    style={{ maxWidth: "150px", margin: 'auto', fontSize: '13px' }}
                                                    onChange={(event) => handleInputNoOfAdults(event, data.from_date_display)}
                                                />   
                                                {hideOldDiv && ChangedNoOfAdults[data.from_date_display] && (                                                    
                                                    <div style={{ marginTop: '4px', textAlign: 'center' }}>
                                                    {originalData.find(d => d.from_date_display === data.from_date_display) && originalData.find(d => d.from_date_display === data.from_date_display).no_of_adults_old !== '' ? (
                                                        <div style={{
                                                            background: '#f06548',
                                                            padding: '2px 8px',
                                                            borderRadius: '4px',
                                                            color: '#fff',
                                                            fontSize: '11px',
                                                            display: 'inline-block'
                                                            }}>
                                                            Old : {originalData.find(d => d.from_date_display === data.from_date_display).no_of_adults_old}
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                )}                                             
                                            </div>
                                        </td>
                                        <td>
                                            {/* <i className="ri-code-box-line"></i> */}
                                            <div className="flex-shrink-0">
                                                <div className="form-check">
                                                    <Input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={checkboxId_budget}
                                                        checked={data.isChecked}
                                                        style={{ margin: 'auto', display: 'block', pointerEvents: 'none' }}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            </div>

            <Modal
                isOpen={showImportModal}
                toggle={() => setShowImportModal(false)}
                centered
                >
                <ModalHeader toggle={() => setShowImportModal(false)}>
                    Import Budget Data
                </ModalHeader>

                <ModalBody>

                    {/* Aggregator */}
                    <Label>Time Period</Label>
                    <Input
                    type="select"
                    className="mb-3"
                    value={importAggregator}
                    onChange={(e) => setImportAggregator(e.target.value)}
                    >
                    <option value="day">Day</option>
                    <option value="month">Month</option>
                    <option value="year">Year</option>
                    </Input>

                    {/* Year */}
                    <Label>Year</Label>
                    <Input
                    type="select"
                    className="mb-3"
                    value={importYear}
                    onChange={(e) => setImportYear(e.target.value)}
                    >
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    </Input>

                    {/* Meal Period */}
                    <Label>Meal Period</Label>
                    <Input
                    type="select"
                    className="mb-3"
                    value={importMealPeriod}
                    onChange={(e) => setImportMealPeriod(e.target.value)}
                    >
                    <option value="0">All Meal Periods</option>
                    {filtermealperiod.map((item) => (
                        <option key={item.sp_id} value={item.sp_id}>
                        {item.title}
                        </option>
                    ))}
                    </Input>

                    {/* File Upload */}
                    <Label>Excel File (Max 10MB)</Label>
                    <Input
                    type="file"
                    accept=".xls,.xlsx"
                    onChange={(e) => setImportFile(e.target.files[0])}
                    />

                </ModalBody>

                <ModalFooter>
                    <Button
                    outline
                    onClick={() => setShowImportModal(false)}
                    >
                    Cancel
                    </Button>

                    <Button
                    color="primary"
                    disabled={importLoading}
                    onClick={handleImportSubmit}
                    >
                    {importLoading ? "Importing..." : "Import"}
                    </Button>
                </ModalFooter>
                </Modal>

        </>)
}
export default BudgetTab;